import { SpyneTrait } from "spyne";

export class CodeBlockUtilsTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = "codeBlockUtil$";

    super(context, traitPrefix);
  }

  static codeBlockUtil$HelloWorld() {
    return "Hello World";
  }

  static codeBlockUtil$FormatLines(
    lines = [],
    parentVsid = "xxxx",
    formatType = "string",
  ) {
    const onUpdateLines = (codeElClass = "next") => {
      const sel = `[data-vsid="${parentVsid}"]`;

      const codeEl = document.querySelector(`${sel} .code.${codeElClass}`);

      const updateLine = (lineNum) => {
        try {
          const lineSel = `pre.line-${lineNum}`;
          const lineEl = codeEl.querySelector(lineSel);
          if (lineEl === null && codeEl !== null) {
            window.setTimeout(() => onUpdateLines(codeElClass), 1000);
            //console.warn('CODE BLOCK IS MISSING', {codeElClass, codeEl, lineNum});
            return;
          }
          //console.log("CODE EL ", {lineEl, codeEl, lineNum})

          const textContent = lineEl.textContent;
          const span = document.createElement("span");
          span.classList.add(`hljs-${formatType}`);
          span.textContent = textContent;
          //console.log("LINE BLOCK UTILS ",{sel, codeEl, lineEl, lineSel, textContent})
          lineEl.innerHTML = "";
          lineEl.textContent = "";
          lineEl.appendChild(span);
        } catch (e) {
          console.warn("code appears to no longer exists");
        }
      };

      //lineEl.innerHTML = `<span class="hljs-${formatType}">${textContent}</span>`;
      lines.forEach(updateLine);
    };

    const onUpdateMainCode = () => onUpdateLines("main");

    window.setTimeout(onUpdateLines, 200);
    window.setTimeout(onUpdateMainCode, 1000);
  }
}
